import firebase from './index'

export function firebaseFetchAllFactories(dealerID) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('mekh')
      .orderByChild('provider')
      .equalTo(dealerID)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseFetchOneFactory(factoryID) {
  return new Promise((resolve, reject) => {
    firebase
      .database()
      .ref()
      .child('mekh')
      .child(factoryID)
      .once('value')
      .then(snap => {
        resolve(snap.val())
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseCreateFactory(newFactory) {
  const factoryRef = firebase
    .database()
    .ref()
    .child('mekh')
    .push()

  return new Promise((resolve, reject) => {
    factoryRef
      .set(newFactory)
      .then(resolve(factoryRef.key))
      .catch(error => {
        reject(error)
      })
  })
}

export function firebaseEditFactory(factoryID, UpdateFactory) {
  return firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .set(UpdateFactory)
}

export async function firebaseRemoveFactories(factoryID) {
  return firebase
    .database()
    .ref()
    .child('mekh')
    .child(factoryID)
    .remove()
}
